import type { SVGProps } from 'react'

interface PottedPlantIconProps extends SVGProps<SVGSVGElement> {}

export function PottedPlantIcon(props: PottedPlantIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M350.46-160h258.31q5 0 8.46-2.88 3.46-2.89 5-7.12l43.08-171.92H293.92L337-170q1.54 4.23 5 7.12 3.46 2.88 8.46 2.88Zm0 60q-25.69 0-45.15-15.46-19.46-15.46-26.08-40.16l-46.92-186.3h494.61L680-155.62q-6.62 24.31-26.08 39.96Q634.46-100 608.77-100H350.46ZM213.85-401.92h532.3q6.16 0 10-3.85 3.85-3.85 3.85-9.62v-74.23H200v74.23q0 5.77 4.04 9.62 4.04 3.85 9.81 3.85Zm265.77-235.77q0-82.31 56.96-141.77 56.96-59.46 139.88-75 4.62-1 8.42.62 3.81 1.61 7.43 4.61 3.61 3 4.92 7.12 1.31 4.11.31 8.73-13.7 72.84-64.5 126.15-50.81 53.31-123.43 66.69v90.93h274.23q15.47 0 25.81 10.34Q820-528.92 820-513.46v98.07q0 30.31-21.77 51.89-21.77 21.58-52.08 21.58h-532.3q-30.31 0-52.08-21.58T140-415.39v-98.07q0-15.46 10.35-25.81 10.34-10.34 25.81-10.34h273.46v-90.93Q377-653.92 326.19-707.23q-50.8-53.31-64.5-126.15-1-4.62.31-8.73 1.31-4.12 4.92-7.12 3.62-3 7.43-4.61 3.81-1.62 8.42-.62 82.92 15.54 139.88 75 56.97 59.46 56.97 141.77Z" />
    </svg>
  )
}
